import "./App.css";
import { lazy } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import ErrorE from "./Layout/ErrorE";

import Layout from "./Layout/Layout";

import WrapInSuspense from "./Components/WrapInSuspense";

const Index = lazy(() => import("./Index/Index"));

const Categories = lazy(() => import("./Categories/Categories"));

const ClostridiumDifficile = lazy(
  () => import("./Products/C. Diff RAPID BIOTEC/ClostridiumDifficile"),
);

const AboutUs = lazy(() => import("./AboutUs/AboutUs"));

const ContactUs = lazy(() => import("./ContactUs/ContactUs"));

const routes = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<ErrorE />}>
      <Route element={<Layout />}>
        <Route
          index
          element={
            <WrapInSuspense>
              <Index />
            </WrapInSuspense>
          }
        />

        <Route path="/products/:cat">
          <Route
            index
            element={
              <WrapInSuspense>
                <Categories />
              </WrapInSuspense>
            }
          />
          <Route
            path="Clostridium_Difficile"
            element={
              <WrapInSuspense>
                <ClostridiumDifficile />
              </WrapInSuspense>
            }
          />
        </Route>

        <Route
          path="about_us"
          element={
            <WrapInSuspense>
              <AboutUs />
            </WrapInSuspense>
          }
        />
        <Route
          path="contact_us"
          element={
            <WrapInSuspense>
              <ContactUs />{" "}
            </WrapInSuspense>
          }
        />
      </Route>
    </Route>,
  ),
);

function App() {
  return <RouterProvider router={routes} />;
}

export default App;
